import { graphql } from '@generated/gql';

export const SEARCH_SHELF = graphql(/** GraphQL */ `
  query addSecuritiesDialogSearchShelf($input: FetchFinancialProductsInput!) {
    fetchFinancialProducts(input: $input) {
      totalCount
      financialProducts {
        id
        ticker
        isCash
        exchange
        currency
        currentPriceCents
        translatedName {
          ...ProductTranslatedString
        }
        primaryAssetClass {
          id
          name
          translatedName {
            ...ProductTranslatedString
          }
        }
        secondaryAssetClass {
          id
          name
          translatedName {
            ...ProductTranslatedString
          }
        }
        tertiaryAssetClass {
          id
          name
          translatedName {
            ...ProductTranslatedString
          }
        }
      }
    }
  }
`);
